// extracted by mini-css-extract-plugin
export var centerAlign = "Columns-module--center--align--37d2c";
export var columns = "Columns-module--columns--8f87c";
export var formerStretch = "Columns-module--former-stretch--b5baa";
export var latterStretch = "Columns-module--latter-stretch--e53db";
export var leftAlign = "Columns-module--left--align--c8a75";
export var lgGap = "Columns-module--lg-gap--2764d";
export var mdGap = "Columns-module--md-gap--6d18c";
export var reverseDirection = "Columns-module--reverse-direction--0ed52";
export var rightAlign = "Columns-module--right--align--ec0e7";
export var smGap = "Columns-module--sm-gap--c220a";
export var xlGap = "Columns-module--xl-gap--7a091";
export var xsGap = "Columns-module--xs-gap--6f011";